import baseApi from '@store/api/baseApi';

export const S3UploadApis = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		// File upload
		// initiate File upload for less then <= 100 MB
		initiateSingleFileUpload: builder.mutation({
			query: ({ body, url = '/doc/s3-upload/initiate' }) => ({
				url: url,
				method: 'POST',
				body,
				headers: {
					'Content-Type': 'application/json'
				}
			})
		}),
		// initiate File upload for greater then >= 100 MB
		initiateMultipartFileUpload: builder.mutation({
			query: ({ body, url = '/doc/s3-multipart-upload/initiate' }) => ({
				url: url,
				method: 'POST',
				body,
				headers: {
					'Content-Type': 'application/json'
				}
			})
		}),
		// Upload Single chunk file to S3 signed URL (for less then 100 MB)
		uploadSingleChunk: builder.mutation({
			queryFn: async ({ url, body, fileMimeType }) => {
				try {
					const response = await fetch(url, {
						method: 'PUT',
						body: body,
						headers: {
							'x-amz-acl': 'public-read',
							'Content-Type': fileMimeType
						}
					});

					if (!response.ok) {
						return { error: { status: response.status, data: response.statusText } };
					}

					// Get ETag from response headers
					const etag = response.headers.get('ETag');
					return { data: { eTag: etag } };
				} catch (error) {
					return { error: { status: 'FETCH_ERROR', data: error.message } };
				}
			}
		}),
		// Upload Chunk wise file to S3 signed URL (Greater then 100 MB)
		uploadMultipleChunk: builder.mutation({
			queryFn: async ({
				url,
				body,
				fileMimeType = 'application/json',
				headers = {
					'Content-Type': fileMimeType
				}
			}) => {
				try {
					const response = await fetch(url, {
						method: 'PUT',
						body: body,
						headers
					});

					if (!response.ok) {
						return { error: { status: response.status, data: response.statusText } };
					}

					// Get ETag from response headers
					const etag = response.headers.get('ETag');
					return { data: { eTag: etag } };
				} catch (error) {
					return { error: { status: 'FETCH_ERROR', data: error.message } };
				}
			}
		}),
		// Compleate multipart Chunk upload (for Greater then 100 MB)
		compleateMultipleChunkUpload: builder.mutation({
			query: ({ body, url = '/doc/s3-multipart-upload/complete' }) => ({
				url: url,
				method: 'POST',
				body,
				headers: {
					'Content-Type': 'application/json'
				}
			})
		}),
		// Compleate single Chunk upload (for less then 100 MB)
		compleateSingleChunkUpload: builder.mutation({
			query: ({ body, url = '/doc/s3-upload/complete' }) => ({
				url: url,
				method: 'POST',
				body,
				headers: {
					'Content-Type': 'application/json'
				}
			})
		}),
		// Abort Chunk Upload (will be used if chunks faild after N times of retry)
		abortFileUpload: builder.mutation({
			query: ({ uploadId, key }) => ({
				url: `/doc/s3-multipart-upload/abort?key=${key}&uploadId=${uploadId}`,
				method: 'DELETE'
			})
		})
	})
});

export const {
	// init
	useInitiateMultipartFileUploadMutation,
	useInitiateSingleFileUploadMutation,

	// Chunk
	useUploadSingleChunkMutation,
	useUploadMultipleChunkMutation,

	// Compleate
	useCompleateMultipleChunkUploadMutation,
	useCompleateSingleChunkUploadMutation,

	// Abort
	useAbortFileUploadMutation
} = S3UploadApis;
